import { View, ProgressView} from "@gaming/srvg-classes-core";
import { SettlementGalleryView } from "../SettlementGalleryView";

export class PostMatchOverlay extends View {

    galleryView: SettlementGalleryView;
    progressView: ProgressView;
    subViewRotationInterval: number;

    constructor( options ) {
        options = options || {};
        super( options );

        this.galleryView = this.addSubView( new SettlementGalleryView( {  } ) );
        this.progressView = this.addSubView( new ProgressView( { selector: this.selector + ' .progressView'} ) );
        this.subViewRotationInterval = srvg.overlay_timings.post_match.rotation_interval || 5;

        if( this.galleryView.galleryPageContainerView.subViews.length <= 1 ) {
            this.galleryView.nextButtonView.hide();
            this.galleryView.prevButtonView.hide();
            this.galleryView.pagerView.hide();
        }
    }

    show( animate?:boolean ) {
        if( this.galleryView.galleryPageContainerView.subViews.length > 1 ) {
            var that = this;
            this.galleryView.galleryPageContainerView.startSubViewRotation( this.subViewRotationInterval, function() {
                that.galleryView.pagerView.selectNextIndex();
            } );
        }
        super.show( animate );
    }

    hide( animate?:boolean ) {
        this.galleryView.galleryPageContainerView.stopSubViewRotation();
        super.hide( animate );
    }
}